export default __webpack_public_path__ + "static/media/logo-placeholder-square.52bef0db.svg";